import { useState } from 'react';
import { Package2 } from 'lucide-react';
import { fmtCurrency } from '../../lib/format.js';
import { SaleNumpad } from './sale-numpad.jsx';
import { SaleSheetShell, SellButton } from './sale-sheet-shell.jsx';
import { PriceDeltaNote } from './price-delta-note.jsx';

// Verkaufs-Sheet: Wunschpreis vorbelegt, NumPad sofort offen (Mockup Frame 2).
export function QuickSaleSheet({ item, imageUrl, open, onOpenChange, onSale, dark }) {
  const wish = item ? (item.wish_price != null ? item.wish_price : item.price) ?? 0 : 0;
  const [amount, setAmount] = useState(wish);

  if (!open || !item) return null;

  return (
    <SaleSheetShell
      open={open}
      onClose={() => onOpenChange(false)}
      testId="quick-sale-sheet"
      title={item.name}
      subtitle={<span className="num">{`Wunschpreis ${fmtCurrency(wish)}`}</span>}
      leading={
        <div className="h-14 w-14 shrink-0 overflow-hidden rounded-[12px]">
          {imageUrl ? (
            <img src={imageUrl} alt="" className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-[var(--tint-troedel)]">
              <Package2 className="h-6 w-6 text-[var(--accent-troedel)]" />
            </div>
          )}
        </div>
      }
      footer={
        <>
          <SaleNumpad
            tone="sale"
            prefill={wish}
            wishPrice={wish}
            caption="Ausgehandelter Preis"
            onValueChange={setAmount}
            note={<PriceDeltaNote value={amount} reference={wish} kind="wish" />}
          />
          <SellButton
            amountLabel={fmtCurrency(amount)}
            disabled={!(amount > 0)}
            onClick={() => { onSale?.(item, amount); }}
          />
        </>
      }
    />
  );
}
